<template>
  <marquee-text
    :duration="20"
    :paused="paused"
    class="announcement"
    :key="marqueesList[0].status"
    @touchstart.stop.prevent="paused = true"
    @touchend.stop.prevent="paused = false"
  >
    <!-- @touchstart="paused = true"
    @touchend="paused = false" -->

    <ul class="announcement-list" ref="announcement">
      <li v-for="(mar, key) in marqueesList" :key="key">
        【重要公告】{{ mar.content }}
      </li>
    </ul>
  </marquee-text>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MarqueeText from "vue-marquee-text-component";

export default {
  name: "announcement",
  components: {
    MarqueeText,
  },
  data() {
    return {
      paused: false,
    };
  },
  props: {},
  computed: {
    ...mapGetters({
      webMode: "webMode",
    }),
    ...mapState({
      marqueesList: (state) => state.notice.marqueesList,
      seoSettings: (state) => state.website.seoSettings,
    }),
  },
  methods: {
    async getmarquees(lottery_id) {
      await this.$store.dispatch("notice/getmarquees");
    },
  },
  // async mounted() {
  //   // await this.getmarquees();
  //   const announcement = document.querySelector('.announcement')
  //   announcement.addEventListener('touchstart',() => {
  //     this.paused = true
  //   }, { passive: false })
  //   announcement.addEventListener('touchend',() => {
  //     this.paused = false
  //   }, { passive: false })
  // },
};
</script>

<style scoped>
@import "~@/assets/css/announcement.css";
</style>
